import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutSidebar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-sidebar, grid, window"} maskId="square-filled-radius-0-stroke-1-IconLayoutSidebar"><path d="M3 21V3H9V21L3 21Z" fill="currentColor"/><path d="M10 21L21 21V12.5H10V21Z" fill="currentColor"/><path d="M21 11.5V3H10V11.5H21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutSidebar;
